export default "__VITE_ASSET__D81kkamD__"